<template>
  <Modal
    :title="title || 'Ticket'"
    @close="close"
    @confirm="confirm"
    :hide-footer="true"
    size="large"
  >
    <template #body>
      <div v-if="!ticketOptionsStatus.isLoaded" class="my-4">
        <LoadingState :size="50" />
      </div>
      <template v-else-if="ticketOptions">
        <ContactSupportForm
          :category-id="categoryId"
          :department-id="departmentId"
          :domain="domain"
          :reply="reply"
          :service-id="serviceId"
          :subject="subject"
          :ticket-options="ticketOptions"
          :forceSubmittable="forceSubmittable || false"
          @close="close"
          @confirm="confirm"
          :testId="`${title ? `${title.toLowerCase().replaceAll(' ', '-')}` : `ticket`}`"
        />
      </template>
      <div v-else>
        <ErrorState />
      </div>
    </template>
  </Modal>
</template>

<script>
import { computed, onMounted } from "vue";
import ContactSupportForm from "@/components/smart/forms/ContactSupportForm";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "ContactSupport",
  props: {
    category: String,
    department: String,
    domain: String,
    forceSubmittable: Boolean,
    reply: String,
    serviceId: Number,
    subject: String,
    title: String,
  },
  emits: ["close", "confirm"],
  components: {
    ContactSupportForm,
    ErrorState,
    LoadingState,
    Modal,
  },
  setup(props, { emit }) {
    const ticketOptions = computed(() => store.getters["tickets/getOptions"]);
    const ticketOptionsStatus = computed(() => store.getters["tickets/getOptionsStatus"]);
    const departmentId = computed(() => {
      const department = props.department;
      if (department) {
        return ticketOptions.value?.departments?.find((item) => item.identity === department)?.id;
      }
      return null;
    });

    const categoryId = computed(() => {
      const category = props.category;
      if (category) {
        return ticketOptions.value?.categories?.find((item) => item.identity === category)?.id;
      }
      return null;
    });

    onMounted(() => {
      store.dispatch("tickets/getOptions");
    });

    const close = () => emit("close");
    const confirm = () => emit("confirm");

    return {
      categoryId,
      close,
      confirm,
      departmentId,
      ticketOptions,
      ticketOptionsStatus,
    };
  },
};
</script>
